export const GET_UNCONFIRMED_TRANSACTIONS_SUCCESS =
  'GET_UNCONFIRMED_TRANSACTIONS_SUCCESS';
